import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableMagicLinkStatus = loadable(
  () => import('./MagicLinkVerification'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadableMagicLinkStatus;
